// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3727e5d8","389":"3585d8a6","455":"832eb323","977":"0a89e308"}[chunkId] + ".chunk.js";
};